package com.essntl.core.whatsapp.data.response

import kotlinx.serialization.Serializable

@Serializable
internal data class WhapiSendMessageResponseDto(
    val message: WhapiMessageDto
)
